/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAxios } from 'ts/createAxios';
import {
  StorageSiteReceivedItemResponseType,
  StorageSiteReceivedItemsResponseType,
  StorageSiteScanQrItemType,
  StorageSiteScanQrResponseType,
} from 'types/siteStorage';
import { API_ENDPOINTS } from 'util/endPoints';
import { handleError } from 'util/errorHandler';

export const getStorageSiteMaterialNames = async (params: {
  successCallback?: (data: { name: string }[]) => void;
  failedCallback?: (error: any) => void;
}) => {
  const { successCallback, failedCallback } = params;

  try {
    const { data } = await createAxios().get<{
      data: { name: string }[];
    }>(API_ENDPOINTS.SITE_STORAGE_MATERIAL_NAMES);

    successCallback?.(data.data);
  } catch (error) {
    handleError(error);
    failedCallback?.(error);
  }
};

export const getStorageSiteFromSites = async (params: {
  successCallback?: (data: { id: string; name: string }[]) => void;
  failedCallback?: (error: any) => void;
}) => {
  const { successCallback, failedCallback } = params;

  try {
    const { data } = await createAxios().get<{
      data: { id: string; name: string }[];
    }>(API_ENDPOINTS.SITE_STORAGE_FROM_SITES);

    successCallback?.(data.data);
  } catch (error) {
    handleError(error);
    failedCallback?.(error);
  }
};

export const getStorageSiteReceivedItems = async (params: {
  dateFrom?: string;
  dateTo?: string;
  fromSiteIds?: string[];
  materialNames?: string[];
  page?: number;
  take?: number;
  successCallback?: (data: StorageSiteReceivedItemResponseType[]) => void;
  failedCallback?: (error: any) => void;
}) => {
  const {
    dateFrom,
    dateTo,
    fromSiteIds,
    materialNames,
    page = 0,
    take,
    successCallback,
    failedCallback,
  } = params;

  try {
    const { data } =
      await createAxios().get<StorageSiteReceivedItemsResponseType>(
        API_ENDPOINTS.SITE_STORAGE_RECEIVED_ITEMS,
        {
          params: { dateFrom, dateTo, fromSiteIds, materialNames, page, take },
        }
      );

    successCallback?.(data.data);
  } catch (error) {
    handleError(error);
    failedCallback?.(error);
  }
};

export const scanStorageSiteQr = async (params: {
  qrCode: string;
  successCallback?: (data: StorageSiteScanQrItemType) => void;
  failedCallback?: (error: any) => void;
}) => {
  const { qrCode, successCallback, failedCallback } = params;

  try {
    const { data } = await createAxios().post<StorageSiteScanQrResponseType>(
      API_ENDPOINTS.WORK_HISTORIES_STORAGE_SITES_SCAN_QR,
      {
        qrCode,
      }
    );

    const firstItem = data.items?.[0];

    if (firstItem) {
      successCallback?.(firstItem);
    }
  } catch (error) {
    handleError(error);
    failedCallback?.(error);
  }
};

export const registerStorageSite = async (params: {
  processingObjectIds: string[];
  temporaryStorageId: number | null;
  successCallback?: () => void;
  failedCallback?: (error: any) => void;
}) => {
  const {
    processingObjectIds,
    temporaryStorageId,
    successCallback,
    failedCallback,
  } = params;

  try {
    await createAxios().post(
      API_ENDPOINTS.WORK_HISTORIES_STORAGE_SITES_REGISTER_STORAGE,
      {
        processingObjectIds,
        temporaryStorageId,
      }
    );

    successCallback?.();
  } catch (error) {
    handleError(error);
    failedCallback?.(error);
  }
};
